export default __webpack_public_path__ + "static/media/gallery_03.0cc0f8fc.jpg";